export function isPublicTopic(topic: any) {
  return (
    !topic.languageCode ||
    topic.languageCode === 'en' ||
    topic.slug === 'meditacion-guiada-en-espanol'
  );
}
